
import { Options, Vue } from "vue-class-component";
import Sidebar from "../components/Sidebar.vue"; // @ is an alias to /src
import NotificationSide from "../components/NotificationSide.vue";
import TransportMeans from "../components/Dashboard/TransportMeans.vue";
import TicketBooking from "../components/BookingProcedures/TicketBooking.vue";
import MobileSidebar from '../components/MobileSidebar.vue';
@Options({
  components: {
    Sidebar,
    NotificationSide,
    TransportMeans,
    TicketBooking,
    MobileSidebar
  },

  data() {
    return {
      ticketId: "",
      favourite_company: ''
    };
  },
  updated() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    let ticketId = params.get("ticket");

    this.ticketId = ticketId;
  },
  
})
export default class Dashboard extends Vue {}
